// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static-1764332573586/css/" + chunkId + "." + {"128":"ef9ab5ff","157":"c845f213","466":"e2662719","481":"623407d8"}[chunkId] + ".css";
};